import {DetailsFieldsGrid} from '@/components/ui/details-atoms/DetailsAtoms'
import {Mail01Icon, Phone01Icon, PhoneIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {StyledPatientContactsDetailsGrid} from '@/features/patients/components/patient-contacts-details/style'
import {PatientExtended} from '@/features/patients/types'
import {useTranslation} from '@/translations/i18n'
import {useTheme} from 'styled-components'

export const PatientContactsDetails = ({patient}: {patient: PatientExtended}) => {
    const {t} = useTranslation()
    const {palette} = useTheme()
    return (
        <DetailsFieldsGrid>
            {patient.contacts.map((contactData, index) => (
                <StyledPatientContactsDetailsGrid key={index}>
                    {contactData.type == 'telephone' ? (
                        <PhoneIcon size={14} color={palette.neutral[500]} />
                    ) : contactData.type == 'mobile_phone' ? (
                        <Phone01Icon size={14} color={palette.neutral[500]} />
                    ) : (
                        <Mail01Icon size={14} color={palette.neutral[500]} />
                    )}
                    <Text palette="neutral" shade="500" size="textSm">
                        {t(`commons:${contactData.type}`)} {contactData.label && `(${contactData.label})`}
                    </Text>
                    <Text palette="neutral" shade="950" size="textMd" weight="500" style={{gridArea: 'value'}}>
                        {contactData.contact}
                    </Text>
                </StyledPatientContactsDetailsGrid>
            ))}
        </DetailsFieldsGrid>
    )
}
